export default __webpack_public_path__ + "static/mobile-podcast-play.svg";